/* eslint dom-in-jsx/no-jquery-in-jsx: 0 */

import React from 'react';

export default class HierarchyFieldBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      levels: [],
      parent: null,
      newLevel: '',
      editMode: false,
      nodeSelected: false,
      isModalOpen: false,
      errors: [],
    };
  }

  _request(type, url, data) {
    return $.ajax({
      type: type,
      url: url,
      data: data,
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      },
    });
  }

  loadData(parent) {
    let endpoint;

    if (parent !== null) {
      this.setState({ parent: parent });
    }
    this.setState({ nodeSelected: false });
    endpoint = parent === null ? 'roots' : `${parent.id}/children`;
    $.getJSON(`/${currentCustomer}/hierarchy_fields/${endpoint}`).done((data) =>
      this.setState({ levels: data }),
    );
  }

  addNode() {
    const parent = this.state.parent === null ? '' : this.state.parent.id;

    this._request('POST', `/${currentCustomer}/hierarchy_fields`, {
      parent_id: parent, // eslint-disable-line camelcase
      hierarchy_field: {
        // eslint-disable-line camelcase
        name: this.state.newLevel,
      },
    })
      .done((data) => this.setState({ levels: data, newLevel: '' }))
      .fail((response) => {
        if (typeof response.responseJSON.errors === 'undefined') {
          return;
        }
        this.setState({ errors: Object.values(response.responseJSON.errors) });
      });
  }

  handleNewInput(e) {
    this.setState({ newLevel: e.target.value, errors: [] });
  }

  endEdit() {
    var errors;

    if (this.state.levels.length === 0) {
      this.setState({ editMode: false });
    } else {
      this._request('PUT', `/${currentCustomer}/hierarchy_fields/batch`, {
        levels: this.state.levels,
      })
        .done((data) =>
          this.setState({
            levels: data,
            editMode: false,
            newLevel: '',
            errors: [],
          }),
        )
        .fail((response) => {
          if (typeof response.responseJSON.errors === 'undefined') {
            return;
          }

          errors = response.responseJSON.errors
            .map((i) => {
              return Object.values(i);
            })
            .flat(2);

          errors = errors.filter(function (item, pos) {
            return errors.indexOf(item) == pos;
          });

          this.setState({ errors: errors });
        });
    }
  }

  editMode(mode) {
    this.setState({ editMode: mode, newLevel: '', errors: [] });
  }

  handleEdit(e, level) {
    this.state.levels.map((i) => {
      if (i.id == level.id) {
        i.name = e.target.value;
      }
    });
    this.setState({ levels: this.state.levels });
  }

  openLevel(node, data) {
    this.setState({ nodeSelected: node.id });
    this.props.openLevel(node, data);
  }

  openModal(data) {
    var warnModal = new IO.Views.Components.ConfirmationDialog({
      url: `/${currentCustomer}/hierarchy_fields_impacted_objects?level_id=${data.id}`,
      template: 'hierarchy_definitions/impacted_objects',
      method: 'GET',
      modalWidth: 800,
      modalHeight: '80%',
    });

    warnModal.impact(data.id);
    warnModal.answer((proceed) => {
      if (proceed) {
        this.deleteNode(data);
      }
      warnModal.destroy();
    });
  }

  deleteNode(node) {
    this._request(
      'DELETE',
      `/${currentCustomer}/hierarchy_fields/${node.id}`,
      null,
    ).done(() => {
      this.props.deletedLevel(node);
      this.setState({
        levels: this.state.levels.filter((i) => i.id !== node.id),
      });
    });
  }

  render() {
    return (
      <div className='HierarchyFieldBox'>
        <If condition={this.props.opened.indexOf(this.props.data.level) > -1}>
          <div className='HierarchyFieldBoxContent'>
            <h1>
              {this.state.parent !== null ? `${this.state.parent.name} > ` : ''}
              {this.props.data.name}
            </h1>
            <div className='hierarchyErrors'>
              {' '}
              {this.state.errors.map((i) => {
                return (
                  <p
                    key={i}
                    className='errorMessage'
                  >
                    {i}
                  </p>
                );
              })}{' '}
            </div>
            <If condition={!this.state.editMode}>
              <If condition={HierarchyLevels.canEdit}>
                <button
                  className='edit-button mini ui primary button'
                  onClick={() => this.editMode(true)}
                >
                  Edit
                </button>
              </If>
              <ul className='list-nodes'>
                {' '}
                {this.state.levels.map((i) => {
                  return (
                    <li
                      key={i.id}
                      className={
                        i.id == this.state.nodeSelected ? 'active' : ''
                      }
                      onClick={(e) => this.openLevel(i, this.props.data, e)}
                    >
                      {i.name}
                    </li>
                  );
                })}{' '}
              </ul>
              <input
                placeholder='Level item name'
                type='text'
                value={this.state.newLevel}
                onChange={this.handleNewInput.bind(this)}
                onKeyPress={(e) => {
                  if (e.which == 13) {
                    this.addNode();
                  }
                }}
              />
            </If>
            <If condition={this.state.editMode}>
              <button
                className='edit-button mini ui primary button'
                onClick={this.endEdit.bind(this)}
              >
                Save
              </button>
              <ul>
                {this.state.levels.map((i) => {
                  return (
                    <li
                      key={i.id}
                      className={`edit-item ${HierarchyLevels.canDelete ? '' : 'no-delete'}`}
                    >
                      <input
                        id={i.id}
                        type='text'
                        value={i.name}
                        onChange={(e) => this.handleEdit(e, i)}
                      />
                      <If condition={HierarchyLevels.canDelete}>
                        <button
                          className='ui icon red mini button'
                          onClick={() => this.openModal(i)}
                        >
                          <i className='icon minus circle'></i>
                        </button>
                      </If>
                    </li>
                  );
                })}{' '}
              </ul>
            </If>
          </div>
        </If>
      </div>
    );
  }
}
